import { TenderOffer } from 'types';

type MaximumSaleByType = {
  stocks: number;
  phantoms: number;
};

type UnitsByPlan = {
  total: number;
  phantoms: number;
  stocks: number;
  warrants: number;
};

type Eligible =
  | {
      type: 'PARTNER';
      units: number;
    }
  | {
      type: string;
      units: UnitsByPlan;
    };

const min = (a?: number, b?: number) =>
  a != null && b != null ? Math.min(a, b) : undefined;

const percentOf = (value = 0, percent = 0) =>
  Math.floor((value * percent) / 100);
type GetMaximumSaleUnitsProps = {
  eligible?: Eligible;
  tenderOffer: TenderOffer;
};

export const getMaximumSaleUnitsByType = ({
  eligible,
  tenderOffer,
}: GetMaximumSaleUnitsProps): MaximumSaleByType => {
  if (!eligible || eligible.type === 'PARTNER') {
    return { stocks: 0, phantoms: 0 };
  }

  const units = eligible.units as UnitsByPlan;

  if (!units) {
    return { stocks: 0, phantoms: 0 };
  }

  if (tenderOffer.sellAll) {
    return {
      stocks: units.stocks,
      phantoms: units.phantoms,
    };
  }

  const phantoms = (() => {
    if (tenderOffer.maxPhantoms) {
      return min(units.phantoms, tenderOffer.maxPhantoms) ?? 0;
    }

    if (tenderOffer.maxPercentPhantoms) {
      return percentOf(units.phantoms, tenderOffer.maxPercentPhantoms);
    }

    return 0;
  })();

  const stocks = (() => {
    if (tenderOffer.maxStocks) {
      return min(units.stocks, tenderOffer.maxStocks) ?? 0;
    }

    if (tenderOffer.maxPercentStocks) {
      return percentOf(units.stocks, tenderOffer.maxPercentStocks);
    }

    return 0;
  })();

  return { stocks, phantoms };
};
